import Vue from 'vue'
import { store } from '@App/Store/Store'
import { shortcuts } from '@App/GlobalShortcuts'

let instânciaPáginaVue = null
let createdInstances = []

export function inicializarVueNaPágina() {
    if (instânciaPáginaVue) {
        instânciaPáginaVue.$destroy()
    }

    let root = document.querySelector('[data-reflinks-dynamic]')

    instânciaPáginaVue = new Vue({
        el: root,
        store: store,
    })
}

/**
 * Inicializa vue no elemento. A flag global é usada para bindar o vue no menu de módulos
 * lateral, que é instanciado uma única vez.
 *
 * @param {HTMLElement} elemento
 * @param {boolean} global
 */
export function inicializarVueNoElemento(elemento, global = false) {
    if (!elemento) return

    let instânciaLocal = new Vue({
        el: elemento,
        store: store,
        mixins: global ? shortcuts() : [],
    })

    if (instânciaPáginaVue) {
        if (!document.body.contains(instânciaPáginaVue.$el)) {
            instânciaPáginaVue.$destroy()
        }
    }

    createdInstances = createdInstances.filter(vue => {
        if (!document.body.contains(vue.$el)) {
            vue.$destroy()
            return false
        }
        return true
    })

    createdInstances.push(instânciaLocal)

    return instânciaLocal
}
